import { useBoolean } from "react-use";
import type { MarketingEmailTemplate } from "@/react/types/MarketingEmailTemplates";
import { RenameTemplateModal } from "../RenameTemplateModal";

export const useRenameTemplate = ({
  template,
}: {
  template: MarketingEmailTemplate;
}) => {
  const [isOpen, toggleIsOpen] = useBoolean(false);

  return {
    renameTemplateElement: (
      <RenameTemplateModal
        template={template}
        isOpen={isOpen}
        onClose={toggleIsOpen}
      />
    ),
    openRenameTemplateModal: toggleIsOpen,
  };
};
